import { render, staticRenderFns } from "./CompanyPerson.vue?vue&type=template&id=593dab6e&scoped=true&"
import script from "./CompanyPerson.vue?vue&type=script&lang=js&"
export * from "./CompanyPerson.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPerson.vue?vue&type=style&index=0&id=593dab6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593dab6e",
  null
  
)

export default component.exports